<script setup lang="ts">
import { watch, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { useUiStore } from './stores/uiStore'
import { useUserStore } from './stores/userStore'
import { useFrameStore } from './stores/frameStore'

const router = useRouter()
const uiStore = useUiStore()
const userStore = useUserStore()
const frameStore = useFrameStore()

// 在應用最早時刻恢復會話和版面狀態（頁面刷新時保持登入狀態和虛擬桌面狀態）
onBeforeMount(async () => {
  await userStore.restoreSession()

  // 會話恢復完成後，嘗試恢復虛擬桌面狀態
  // 優先順序: sessionStorage frames > initializeFrames
  if (userStore.currentUser && userStore.csrfToken) {
    // 用戶已登入，嘗試從 sessionStorage 恢復虛擬桌面狀態
    const restored = frameStore.restoreFramesFromSession()
    if (!restored) {
      // 如果沒有暫存的 frames，使用初始化
      await frameStore.initializeFrames()
    }
  }
})

function applyCssVars() {
  const el = document.documentElement
  el.style.setProperty('--font-size-base', `${uiStore.fontSize}px`)
  el.style.setProperty('--toolbar-height', `${uiStore.toolbarHeight}px`)
  el.style.setProperty('--btn-height', `${uiStore.btnHeight}px`)
  el.style.setProperty('--ctrl-bar-height', `${uiStore.ctrlBarHeight}px`)
}

watch(() => uiStore.fontSize, applyCssVars, { immediate: true })
</script>

<template>
  <div id="app-container" class="flex flex-col h-screen bg-gray-50">
    <router-view />
  </div>
</template>

<style scoped>
#app-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}
</style>
